import { render, staticRenderFns } from "./AddExtraType.vue?vue&type=template&id=4ca25208&"
import script from "./AddExtraType.vue?vue&type=script&lang=js&"
export * from "./AddExtraType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports